import { Image } from '@/components'
import useFancybox from '@/components/common/fancybox'
import { useReviewsSumary } from '@/features/products/hooks'
import StarIcon from '@mui/icons-material/Star'
import ZoomOutMapIcon from '@mui/icons-material/ZoomOutMap'
import { Box, IconButton, Stack, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'

type Props = {
  src?: string
  title?: string
  data: Product
  onClickScrollReviews?: () => void
}
export default function ImageMobile({ src, title, data, onClickScrollReviews }: Props) {
  const { reviewSummary } = useReviewsSumary(data?.id)
  const reviewAverage = reviewSummary?.avg_rating || 0
  const totalReviews = reviewSummary?.total_review || 0
  const t = useTranslations()
  const [fancyboxRef] = useFancybox()
  return (
    <Box className="image-mobile-product-detail">
      <Stack ref={fancyboxRef} spacing={1} direction={'row'}>
        <Box
          sx={{
            width: 'fit-content',
            position: 'relative',
          }}
          data-fancybox="Image Gallery Product"
          data-src={src}
        >
          <IconButton
            sx={{
              position: 'absolute',
              right: '0',
              top: '0',
              zIndex: '10',
              padding: '4px',
            }}
          >
            <ZoomOutMapIcon
              fontSize="small"
              sx={{
                color: 'primary.main',
              }}
            />
          </IconButton>
          <Image
            src={src}
            alt="Product Image"
            style={{
              borderRadius: '4px',
              width: '100px',
              height: '100px',
              objectFit: 'contain',
              backgroundColor: '#f5f5f5',
            }}
          ></Image>
        </Box>
        <Stack spacing={0.5}>
          <Typography component={'span'} sx={{ fontWeight: 500, fontSize: '1rem' }}>
            {title}
          </Typography>
          <Stack direction={'row'} spacing={0.5} alignItems="center">
            <Stack
              direction="row"
              spacing={0.5}
              alignItems="center"
              sx={{ fontSize: { xs: '0.75rem', md: '1.125rem' } }}
            >
              <Typography fontWeight={600} fontSize="inherit">
                {reviewAverage ? reviewAverage.toFixed(1) : 5}
              </Typography>
              <StarIcon sx={{ color: '#FEB50D', fontSize: { xs: '1rem', md: '1.25rem' } }} />
            </Stack>
            <Typography
              sx={{
                flexGrow: 1,
                fontSize: { xs: '0.75rem', md: '0.875rem' },
                textTransform: 'lowercase',
                color: '#c1c1c1',
                fontWeight: 400,
                cursor: 'pointer',
                '&:hover': { textDecoration: 'underline' },
              }}
              onClick={onClickScrollReviews}
            >
              ({totalReviews} {t('Product.reviews')})
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Box>
  )
}
